/**
 * Document category ID for Communication Records
 * Used in the presign/commit upload flow
 */
export const COMMUNICATION_RECORDS_CATEGORY_ID = '69846b3e213cbccd4529f61c'

/**
 * Maximum number of documents allowed per communication record
 */
export const MAX_DOCUMENTS = 3
